// Pure helpers for the WhatsApp Web (scan QR) card. The UI shows ONLY what the backend confirmed; unknown input never becomes "connected".
export const STATE_LABELS = {
  not_connected: "Belum terhubung", preparing: "Menyiapkan koneksi", awaiting_scan: "Menunggu scan QR", connected: "Terhubung",
  reconnecting: "Menghubungkan ulang", disconnected: "Terputus", error: "Kesalahan",
};
const ACTIVE = new Set(["preparing", "awaiting_scan", "reconnecting"]);
const UNAVAILABLE_TEXT = {
  disabled: "Fitur WhatsApp Web belum diaktifkan.",
  not_configured: "Layanan WhatsApp Web belum dikonfigurasi.",
  worker_unreachable: "Layanan WhatsApp Web sedang tidak dapat dihubungi.",
  worker_error: "Layanan WhatsApp Web sedang bermasalah.",
  bad_worker_response: "Layanan WhatsApp Web memberi jawaban yang tidak dikenali.",
};
const ERROR_REASONS = {
  adapter_unavailable: "Penghubung WhatsApp Web belum terpasang di server ini.",
  connection_replaced: "Sesi digantikan oleh proses lain. Hubungkan ulang bila memang diperlukan.",
  session_invalid: "Sesi tidak berlaku. Hubungkan ulang dengan QR baru.",
  logged_out: "Akun dikeluarkan dari WhatsApp. Hubungkan ulang dengan QR baru.",
  qr_expired: "QR kedaluwarsa. Minta QR baru.",
  qr_limit: "Batas QR tercapai. Coba lagi nanti.",
  reconnect_exhausted: "Gagal menghubungkan ulang. Coba hubungkan kembali.",
  credential_wipe_failed: "Data sesi belum berhasil dihapus. Coba putuskan lagi.",
  user_disconnect: "Koneksi diputuskan.", shutdown: "Layanan dihentikan sementara.",
};

// -> { available, state, label, reason, showQrArea, canConnect, canDisconnect, shouldPoll, text }
export const describeOverview = (payload) => {
  const base = { available: false, state: null, label: "Status tidak dapat dipastikan", reason: null, showQrArea: false, canConnect: false,
    canDisconnect: false, shouldPoll: false, text: "Status belum dapat dipastikan dari server." };
  if (!payload || typeof payload !== "object") return base;
  if (payload.available !== true) {
    return { ...base, text: UNAVAILABLE_TEXT[payload.unavailable_reason] || "WhatsApp Web belum tersedia.", label: "Belum tersedia" };
  }
  const session = payload.session;
  const state = session && typeof session === "object" ? session.state : null;
  if (!STATE_LABELS[state]) return base;
  const reasonText = typeof session.reason_code === "string" ? (ERROR_REASONS[session.reason_code] || null) : null;
  return {
    available: true, state, label: STATE_LABELS[state], reason: reasonText,
    showQrArea: state === "awaiting_scan" && session.qr_available === true,
    canConnect: ["not_connected", "disconnected", "error"].includes(state),
    canDisconnect: state !== "not_connected",
    shouldPoll: ACTIVE.has(state),
    text: state === "connected" ? "WhatsApp Web terhubung." : state === "not_connected" ? "Belum ada akun WhatsApp yang dihubungkan." : "",
    qrExpiresAt: session.qr_expires_at || null,
  };
};

export const secondsLeft = (expiresAt, nowMs = Date.now()) => {
  const t = Date.parse(expiresAt || "");
  return Number.isFinite(t) ? Math.max(0, Math.ceil((t - nowMs) / 1000)) : 0;
};

export const providerLabel = (name) => (name === "whatsapp_web_qr" ? "WhatsApp Web (scan QR)" : name === "whatsapp_cloud_api" ? "WhatsApp Business Cloud API (resmi)" : "Tidak dikenal");
